var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLightbulb28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.037 4.00008C10.1556 4.00008 7 7.15568 7 11.0371C7 12.8149 7.66666 14.5037 8.89633 15.8223C9.57773 16.5481 9.96296 17.4815 9.96296 18.4445V19.9259C9.96296 22.1777 11.7852 24 14.037 24C16.2888 24 18.1111 22.1777 18.1111 19.9259V18.4445C18.1111 17.4815 18.4963 16.5481 19.1926 15.8074C20.4074 14.5036 21.074 12.8148 21.074 11.037C21.074 7.15559 17.9185 4 14.037 4V4.00008ZM15.8889 19.926C15.8889 20.9481 15.0592 21.7778 14.037 21.7778C13.0149 21.7778 12.1852 20.9481 12.1852 19.926V19.5556H15.8889V19.926ZM17.5777 14.2815C16.748 15.1555 16.2146 16.2075 15.9925 17.3335H15.1481V12.5187H12.9259V17.3335H12.0815C11.8593 16.2075 11.3259 15.1557 10.5111 14.2964C9.68152 13.4076 9.22222 12.2373 9.22222 11.0372C9.22222 8.38526 11.3853 6.22239 14.037 6.22239C16.6888 6.22239 18.8518 8.38526 18.8518 11.0372C18.8518 12.2373 18.3925 13.4076 17.5777 14.2815Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightbulb28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;